import {isSpend, useInputMode} from 'store/UserInput';
import {useMainScreenKeyboardInput, useMoneyLeft} from 'ui/utils/core';

export function useFutureBudgetAmount(): number {
  const amount = useMoneyLeft();
  const input = useMainScreenKeyboardInput();
  const mode = useInputMode();

  return isSpend(mode) ? Math.max(amount - input, 0) : amount + input;
}
